/**
 * @desc 监管统计
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import FnancialOverview from './index/FnancialOverview';
import Company from './index/Company';
import State from './index/State';
import RiskHint from './index/RiskHint';
import { getAllOptions } from '../../services/regulatoryStatistical';

export default class RegulatoryStatistical extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            options: null
        };
    }

    componentDidMount() {
        this.getOptions();
    }

    getOptions = () => {
        // TODO 获取公用options
        getAllOptions().then(data => {
            this.setState({ options: data || {} });
        }).catch(() => {
            this.setState({ options: false });
        });
    };

    render() {
        const { options } = this.state;
        return (
            <div>
                <FnancialOverview options={options}/>
                <Company options={options}/>
                <State options={options}/>
                <RiskHint options={options}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/Index.jsx